<template>
  <el-dialog v-model="dialogStatus" :close-on-click-modal="false" @close="close" :title="dialogTitle" :width="width"
    append-to-body>

    <el-form :model="form" :rules="rules" hide-required-asterisk ref="form" >
      <el-form-item prop="channelId">
        <template v-slot:label>
          <div class="form-item__label">渠道名称</div>
        </template>
        <search-channel-select v-model="form.channelId" style="width:100%;" />
      </el-form-item>
      <el-form-item prop="appName">
        <template v-slot:label>
          <div class="form-item__label">应用名称</div>
        </template>
        <el-input v-model="form.appName"  placeholder="应用名称" />
      </el-form-item>
      <el-form-item prop="appBundle">
        <template v-slot:label>
          <div class="form-item__label">应用包名</div>
        </template>
        <el-input v-model="form.appBundle"  placeholder="应用包名" />
      </el-form-item>
      <el-form-item prop="appType">
        <template v-slot:label>
          <div class="form-item__label">应用类型</div>
        </template>
        <div style="display: inline-block; width: 100%">
          <el-radio v-for="item in appTypeList" v-model="form.appType" :label="item.value" :key="item.value">{{
          item.label }}</el-radio>
        </div>
      </el-form-item>
      <el-form-item prop="appUrl">
        <template v-slot:label>
          <div class="form-item__label">下载地址</div>
        </template>
        <el-input v-model="form.appUrl"  placeholder="下载地址" />
      </el-form-item>
      <el-form-item prop="appDesc">
        <template v-slot:label>
          <div class="form-item__label">应用简介</div>
        </template>
        <el-input v-model="form.appDesc" type="textarea" placeholder="应用简介" />
      </el-form-item>
    </el-form>

    <div style="text-align: right;">
      <el-button @click="close" >取消</el-button>
      <el-button @click="submit" type="primary"  :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addAdChannelApp, updateAdChannelApp } from '@/api/advertise/app'
import { appTypeList } from '@/const/app-type'
import SearchChannelSelect from '@/components/SearchChannelSelect'

const form = {
  appId: undefined,
  channelId: undefined,
  appName: undefined,
  appBundle: undefined,
  appType: 1,
  appUrl: undefined,
  appDesc: undefined
}
export default {
  components: {
    SearchChannelSelect
  },
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    },
    data: Object
  },
  emits: ['submit'],
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,

      form: Object.assign({}, form),
      rules: {
        channelId: [{ required: true, message: '请选择渠道名称', trigger: 'change' }],
        appName: [{ required: true, message: '请输入应用名称', trigger: 'blur' }],
        appBundle: [{ required: true, message: '请输入应用包名', trigger: 'blur' }],
        appUrl: [{ required: true, message: '请输入下载地址', trigger: 'blur' }],
        appDesc: [{ required: true, message: '请输入应用简介', trigger: 'blur' }]
      },
      appTypeList: appTypeList
    }
  },
  created() { },
  computed: {
    dialogTitle() {
      return (this.title ? this.title : '') + (this.form.dspId ? '编辑' : '新增')
    }
  },
  methods: {
    show(data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
      }
    },
    close() {
      this.dialogStatus = false
      this.reset()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.appId) {
            this.update(this.form)
          } else {
            this.add(this.form)
          }
        }
      })
    },
    add(form) {
      this.submitLoading = true
      addAdChannelApp(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    update(form) {
      this.submitLoading = true
      updateAdChannelApp(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset() {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  display: block;
}

.el-form-item ::v-deep .el-form-item__label {
  float: left;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}
</style>
